import F3BusCoreRequest from "../../libs/core-api-requests/service/f3BusCoreRequest";
import {
    IF3BusAgentDTO,
    IF3BusAgentsRequestDTO,
    IF3BusDetailsRequestDTO,
    IF3BusRegisterRequestDTO,
} from "../../libs/coreapi-dto/service/f3BusCore";
import CoreApiService from "../../system/api/coreApiService";

export class F3BusCoreDataProvider {
    private readonly _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService;
    }

    getDataRequest(): Promise<F3BusCoreRequest> {
        return this._coreApiService.f3BusCoreRequest;
    }

    agents(
        body: IF3BusAgentsRequestDTO,
        callback?: (agents: IF3BusAgentDTO[]) => void,
        errorCallback?: () => void,
    ) {
        this.getDataRequest()
            .then((request) =>
                request.agents(body, (response) => {
                    if (response.respType === "isCompleted") {
                        callback?.(response.data);
                    } else {
                        errorCallback?.();
                    }
                }),
            )
            .catch(() => errorCallback?.());
    }

    register(body: IF3BusRegisterRequestDTO, callback?: () => void, errorCallback?: () => void) {
        this.getDataRequest()
            .then((request) =>
                request.register(body, (response) => {
                    if (response.respType === "isCompleted") {
                        callback?.();
                    } else {
                        errorCallback?.();
                    }
                }),
            )
            .catch(() => errorCallback?.());
    }

    details(callback?: (details: IF3BusDetailsRequestDTO) => void, errorCallback?: () => void) {
        this.getDataRequest()
            .then((request) =>
                request.details((response) => {
                    if (response.respType === "isCompleted") {
                        callback?.(response.data);
                    } else {
                        errorCallback?.();
                    }
                }),
            )
            .catch(() => errorCallback?.());
    }
}
